/* eslint-disable import/extensions */
import React, { Dispatch, SetStateAction, useEffect } from 'react';

import { Tooltip } from '@mui/material';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import clsx from 'clsx';
import Image from 'next/image';
import { SiweMessage } from 'siwe';
import { useAccount, useDisconnect, useSignMessage } from 'wagmi';

import { loginAPI } from '@/api/login';
import { Spinner } from '@/components/Spinner/Spinner';
import useMediaQuery from '@/hooks/useMediaQuery';
import { isTokenValid } from '@/utils/index';
import { sendNotifcation } from '@/utils/notification';
import MainLogo from 'public/assets/mainLogo.png';
import TooltipImg from 'public/assets/tooltip.svg';

const ChatConnectWalletScreen = ({
  setUserLoggedIn,
}: {
  setUserLoggedIn: Dispatch<SetStateAction<boolean>>;
}) => {
  const isMedia920px = useMediaQuery('(max-width : 920px)');
  const { disconnect } = useDisconnect();
  const { data: signer } = useAccount();
  const { signMessageAsync } = useSignMessage();
  const buttonClass = `relative border-black z-10  border  h-[50px] overflow-ellipsis overflow-hidden whitespace-nowrap flex gap-2 items-center justify-center text-[#008080] ${
    isMedia920px ? 'px-4' : 'px-8'
  } py-4 rounded-lg text-default font-bold`;
  const handleConnect = async () => {
    try {
      const token = localStorage.getItem('token');

      setUserLoggedIn(isTokenValid(token, signer?.address));
      if (!isTokenValid(token, signer?.address) && signer?.address) {
        const message = new SiweMessage({
          domain: window.location.host,
          address: signer?.address,
          statement: `Welcome to Fileverse\nTimestamp: ${new Date().toISOString()}`,
          uri: window.location.origin,
          version: '1',
        });
        const signature = await signMessageAsync({
          message: message.prepareMessage(),
        });
        const result = await loginAPI({
          address: signer?.address,
          signature,
          message: message.prepareMessage(),
        });
        if (result) {
          const accessToken = result?.data?.token;
          localStorage.setItem('token', accessToken);
          localStorage.setItem('address', signer?.address);
          setUserLoggedIn(true);
        }
      }
      return;
    } catch (error) {
      disconnect();
      sendNotifcation('Wallet Disconnected', '', 'danger');
    }
  };
  useEffect(() => {
    handleConnect();
  }, [signer?.address]);
  return (
    <div className="h-full bg-white rounded-lg row-span-6 flex items-center justify-center">
      <div className="w-full flex  justify-center">
        <div className="items-center">
          <div className="flex justify-center mb-8">
            <div className="w-20">
              <Image
                src={MainLogo}
                alt="fileverse"
                width="100%"
                height="100%"
                layout="responsive"
                objectFit="contain"
              />
            </div>
          </div>
          <div className="p-4">
            <div className="flex text-center justify-center">
              <span className="font-semibold text-xl  mr-2">
                Connect to your wallet
              </span>
              <Tooltip
                title="Connect your wallet to be able to comment on this file"
                placement="top"
              >
                <img alt="" src={TooltipImg.src} />
              </Tooltip>
            </div>
            <div className="flex justify-center p-2">
              <p className="w-48 text-gray-400">
                Chat directly with anyone that has access to this file
              </p>
            </div>

            <div className="flex justify-center mt-4">
              <ConnectButton.Custom>
                {({
                  account: modalAccount,
                  chain,
                  openConnectModal,
                  mounted,
                }) => {
                  return (
                    <div>
                      {(() => {
                        if (!mounted || !modalAccount || !chain) {
                          return (
                            <button
                              onClick={openConnectModal}
                              type="button"
                              className={clsx(buttonClass)}
                            >
                              <div className="font-xx text-default text-black leading-3 flex align-center mb-0 mt-auto">
                                Connect
                              </div>
                            </button>
                          );
                        }
                        return (
                          <button type="button" className={clsx(buttonClass)}>
                            <Spinner />
                          </button>
                        );
                      })()}
                    </div>
                  );
                }}
              </ConnectButton.Custom>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatConnectWalletScreen;
